// extracted by mini-css-extract-plugin
module.exports = {"lia-item":"CustomValidationChecklist_lia-item__0ahUP"};